var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFriendlyInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.367 30.9384C226.647 30.2184 225.862 29.6293 225.011 29.1711C223.112 28.1675 220.909 27.8402 218.4 28.1456L187.2 32.7275L160.996 36.5893C158.771 36.9602 156.524 37.8111 154.298 39.0984C152.073 40.3856 149.825 42.1311 147.6 44.3347L90.1963 102.175C86.5309 105.927 83.5418 110.313 81.2291 115.309C78.9163 120.306 77.7598 125.084 77.7598 129.666V181.527C77.7598 204.655 82.9745 223.397 93.4036 237.753C94.4727 239.302 95.6509 240.807 96.8945 242.247C100.887 246.917 105.317 250.647 110.182 253.397C111.775 254.335 113.411 255.142 115.091 255.84C124.669 259.92 135.731 260.706 148.32 258.262C149.28 258.087 150.24 257.804 151.2 257.433C152.138 257.062 153.185 256.56 154.298 255.906C155.411 255.273 156.458 254.575 157.418 253.833C158.356 253.113 159.316 252.284 160.276 251.367C181.811 230.706 198.938 205.571 211.702 175.964C224.465 146.378 230.836 118.778 230.836 93.1638V41.2802C230.836 36.7202 229.68 33.2511 227.367 30.9384ZM191.607 110.313L172.473 143.346L150.96 180.437C149.04 183.753 146.815 186.131 144.262 187.615C141.709 189.077 139.462 189.273 137.564 188.182L117.469 176.444C115.549 175.353 114.589 173.302 114.589 170.291C114.589 167.28 115.549 164.117 117.469 160.8C119.389 157.506 121.615 155.127 124.167 153.644C125.411 152.924 126.589 152.509 127.68 152.422H127.702C128.836 152.291 129.884 152.531 130.865 153.077L144.262 160.713L177.971 102.546C179.891 99.2511 182.16 96.8293 184.8 95.302C185.018 95.1711 185.237 95.062 185.455 94.9747C187.789 93.7747 189.862 93.6656 191.607 94.6693C193.527 95.7602 194.487 97.8111 194.487 100.844C194.487 103.877 193.527 107.018 191.607 110.313Z",
    stroke: "url(#paint0_linear_2501_1410)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.26 160.713L127.7 152.422C128.835 152.291 129.882 152.531 130.864 153.077L144.26 160.713Z",
    stroke: "url(#paint1_linear_2501_1410)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.486 100.844C194.486 103.855 193.526 107.019 191.606 110.313L172.472 143.346L150.959 180.437C149.039 183.753 146.814 186.132 144.261 187.615C141.708 189.077 139.461 189.273 137.563 188.182L117.468 176.444C115.548 175.353 114.588 173.302 114.588 170.292C114.588 167.281 115.548 164.117 117.468 160.801C119.388 157.506 121.613 155.128 124.166 153.644C125.41 152.924 126.588 152.51 127.679 152.422H127.701L144.261 160.713L177.97 102.546C179.89 99.2515 182.159 96.8297 184.799 95.3024C185.017 95.1715 185.235 95.0624 185.454 94.9752C187.788 93.7752 189.861 93.6661 191.606 94.6697C193.526 95.7606 194.486 97.8115 194.486 100.844Z",
    stroke: "url(#paint2_linear_2501_1410)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.009 29.1702C223.111 28.1666 220.908 27.8393 218.399 28.1448L187.199 32.7266L160.995 36.5884C158.769 36.9593 156.522 37.8102 154.297 39.0975C152.071 40.3848 149.824 42.1302 147.599 44.3338L90.1949 102.174C86.5294 105.927 83.5404 110.312 81.2276 115.308C78.9149 120.305 77.7583 125.083 77.7583 129.665V181.527C77.7583 204.654 82.9731 223.396 93.4022 237.752C94.4713 239.301 95.6494 240.807 96.8931 242.247C100.886 246.916 105.315 250.647 110.181 253.396L70.144 233.454L68.202 232.494C62.682 229.636 57.7076 225.599 53.2567 220.428C40.5148 205.57 34.1221 185.323 34.1221 159.708V107.847C34.1221 103.265 35.2786 98.4866 37.5914 93.4902C39.9041 88.4938 42.8931 84.1084 46.5586 80.3557L103.962 22.5157C106.188 20.3121 108.435 18.5666 110.66 17.2793C112.886 15.9921 115.133 15.1412 117.359 14.7703L174.762 6.32664C177.446 5.99937 179.759 6.39209 181.722 7.54846L225.009 29.1702Z",
    stroke: "url(#paint3_linear_2501_1410)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.352 255.97L115.091 255.84",
    stroke: "url(#paint4_linear_2501_1410)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_1410",
    x1: 154.298,
    y1: 28.0356,
    x2: 154.298,
    y2: 259.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2501_1410",
    x1: 135.98,
    y1: 152.387,
    x2: 135.98,
    y2: 160.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2501_1410",
    x1: 154.537,
    y1: 93.9888,
    x2: 154.537,
    y2: 188.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2501_1410",
    x1: 129.566,
    y1: 6.21558,
    x2: 129.566,
    y2: 253.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2501_1410",
    x1: 115.221,
    y1: 255.84,
    x2: 115.221,
    y2: 255.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFriendlyInterface);
export default __webpack_public_path__ + "static/media/User-Friendly-Interface.cc57229212db1136adc821a919bed2c0.svg";
export { ForwardRef as ReactComponent };